import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import FilterDramaOutlinedIcon from '@mui/icons-material/FilterDramaOutlined'
import NightsStayOutlinedIcon from '@mui/icons-material/NightsStayOutlined'
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined'
import { HourSlider } from './HourSlider'
import { TimeBlock } from './SessionPicker'

// TODO: We use a mix of material UI and tailwind. We should consolidate around
// one design library, but for now this works fine.

type SessionsProps = {
  onSliderChange: (timeBlock: TimeBlock, hours: number) => void
  sessionHours: number[]
  disabled: boolean
}

export const Sessions = ({
  onSliderChange,
  sessionHours,
  disabled,
}: SessionsProps): JSX.Element => {
  const iconStyling = { fontSize: 48, color: 'white' }
  return (
    <div className='w-full grid grid-cols-4 md:grid-cols-8 gap-y-6 gap-x-3 justify-items-center items-center'>
      <HourSlider
        color='#F97068'
        sessionText='Morning'
        timeIntervalText='6 AM - 12 PM'
        value={sessionHours[TimeBlock.Morning]}
        onSliderChange={(event) =>
          onSliderChange(TimeBlock.Morning, event.target.value)
        }
        disabled={disabled}
      >
        <Icon colorClass='bg-[#F97068]'>
          <WbSunnyOutlinedIcon sx={iconStyling} />
        </Icon>
      </HourSlider>
      <HourSlider
        color='#AFCBFF'
        sessionText='Afternoon'
        timeIntervalText='12 PM - 6 PM'
        value={sessionHours[TimeBlock.Afternoon]}
        onSliderChange={(event) =>
          onSliderChange(TimeBlock.Afternoon, event.target.value)
        }
        disabled={disabled}
      >
        <Icon colorClass='bg-brand-light-purple'>
          <FilterDramaOutlinedIcon sx={iconStyling} />
        </Icon>
      </HourSlider>
      <HourSlider
        color='#53599A'
        sessionText='Evening'
        timeIntervalText='6 PM - 12 AM'
        value={sessionHours[TimeBlock.Evening]}
        onSliderChange={(event) =>
          onSliderChange(TimeBlock.Evening, event.target.value)
        }
        disabled={disabled}
      >
        <Icon colorClass='bg-[#53599A]'>
          <NightsStayOutlinedIcon sx={iconStyling} />
        </Icon>
      </HourSlider>
      <HourSlider
        color='#474953'
        sessionText='Overnight'
        timeIntervalText='12 AM - 6 AM'
        value={sessionHours[TimeBlock.Overnight]}
        onSliderChange={(event) =>
          onSliderChange(TimeBlock.Overnight, event.target.value)
        }
        disabled={disabled}
      >
        <Icon colorClass='bg-[#474953]'>
          <AutoAwesomeOutlinedIcon sx={iconStyling} />
        </Icon>
      </HourSlider>
    </div>
  )
}

type IconProps = React.PropsWithChildren<{
  colorClass: string
}>

const Icon = ({ children, colorClass }: IconProps): JSX.Element => (
  <div
    className={`h-20 w-20 rounded-2xl flex justify-self-end md:justify-self-auto justify-center items-center ${colorClass}`}
  >
    {children}
  </div>
)
